module.exports = __webpack_public_path__ + "81ca42dfc2a1236afd8c00161ccf5e43.png";